// extracted by mini-css-extract-plugin
module.exports = {"info_block":"style_info_block__1yky-","info_block__title":"style_info_block__title__-JxKa","info_block__text":"style_info_block__text__1tOJA"};